export default class Storage {
  constructor (storeObject) {
    this.storage = storeObject
  }

  set (key, value) {
    this.storage.setItem(key, value)
    return this.storage.getItem(key)
  }

  get (key, defaultValue) {
    return this.storage.getItem(key) || defaultValue
  }

  setObject (key, value) {
    this.set(key, JSON.stringify(value))
    return this.getObject(key)
  }

  getObject (key) {
    return JSON.parse(this.get(key) || null)
  }

  remove (key) {
    this.storage.removeItem(key)
  }
}
